import type { GanttTipProps } from "./types-gantt-tip";
import { GanttTipView } from "./view-gantt-tip";

/** Card do tooltip das barras do Gantt (Figma: tooltip-gantt-datas / tooltip-gantt-cancelada), em portal. */
export function GanttTip(props: GanttTipProps) {
  return <GanttTipView {...props} />;
}

export type * from "./types-gantt-tip";
